import { DOMProvider, DefaultDOMProvider } from './ModalInterfaces';

/**
 * ModalDOMManager - Handles DOM manipulation, specifically moving modals to document.body
 */
export class ModalDOMManager {
    private _modalElement: Element;
    private _domProvider: DOMProvider;

    constructor(modalElement: Element, domProvider?: DOMProvider) {
        this._modalElement = modalElement;
        this._domProvider = domProvider || new DefaultDOMProvider();
    }

    /**
     * Move modal to document.body level if it's not already there
     * This ensures proper isolation of background content
     */
    public moveToBody(): void {
        // Only move if not already a direct child of body
        if (this._modalElement.parentElement !== this._domProvider.getBody()) {
            // Remove from current location and append to body
            this._modalElement.remove();
            this._domProvider.appendChild(this._domProvider.getBody(), this._modalElement);
        }
    }

    /**
     * Check if the modal is currently a direct child of document.body
     */
    public isInBody(): boolean {
        return this._modalElement.parentElement === this._domProvider.getBody();
    }

    /**
     * Get the modal element
     */
    public getElement(): Element {
        return this._modalElement;
    }
}